import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import {Objects} from "components";

export default class Categories extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Categories._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.modalCategoryEdit = false;
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns =
			[
				{
					Header: "Name",
					accessor: "name",
				},
				{
					Header: "Edit",
					id: "note_add",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 50,
					accessor: obj => obj.pkey,
					Cell: props => {
						return (
							<Button color="green-meadow" size={"sm"} block={true} onClick={() => {
								this.setState({category: props.original.pkey});
								this.handleToggleModal('modalCategoryEdit')
							}}>
								<Edit fontSize={'small'}/>
							</Button>
						);
					}
				},
			]
		return (
			<div className={'box-body'}>
				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Category"}
					object={Objects.Category}
					history={history}
					toggle={this.state.modalCategoryEdit}
					reportClose={this.reportClose('modalCategoryEdit')}
					id={this.state.category}
					afterSave={() => {this.setState({key: Math.random()})}}
					title={"Update Category"}
					hideGoTo={true}
				/>
				<Card>
					<CardContent>
						<ReactTable
							key={this.state.key}
							columns={columns}
							onPageSizeChange={this.onPageSizeChange}
							pageSize={limit}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							defaultSorted={[
								{
									id: 'ranking'
								}
							]}
							showPagination={true}
							defaultPageSize={limit}
							className="-striped -highlight"
						/>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>
			</div>
		)
	}
}
